import { render, staticRenderFns } from "./ViolationFilter.vue?vue&type=template&id=4c485b44&scoped=true&"
import script from "./ViolationFilter.vue?vue&type=script&lang=js&"
export * from "./ViolationFilter.vue?vue&type=script&lang=js&"
import style0 from "./ViolationFilter.vue?vue&type=style&index=0&id=4c485b44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c485b44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VCol,VRow})
